// extracted by mini-css-extract-plugin
module.exports = {"grid-tablet-breakpoint":"575px","double-space":"16px","container":"ChangeEmailSuccess_container__1-1MM"};